import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, public authService: AuthService) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.authService.isAuthenticated.pipe(
            filter(val => val !== null),
            take(1),
            map(authenticated => {
                if (authenticated) {
                    return true;
                } else {
                    return this.router.createUrlTree(['/']);
                }
            })
        )
    }
}
